import * as React from "react";
import { useEffect } from "react";
import { IntlProvider, MessageFormatElement } from "react-intl";
import { useAtom, useAtomValue } from "jotai";

import { SupportedLocale } from "../../scripts/i18n/types";

import { localeAtom, translationsAtom } from "@/i18n/atoms";

type LocaleMessages = Record<
  SupportedLocale,
  () => Promise<{ default: Record<string, MessageFormatElement[]> }>
>;

const localeMessages: LocaleMessages = Object.values(SupportedLocale).reduce(
  (acc, locale) => ({
    ...acc,
    [locale]: () => import(`@/i18n/compiled-locales/${locale}.json`),
  }),
  {} as LocaleMessages,
);

export const TranslationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const locale = useAtomValue(localeAtom);
  const [translations, setTranslations] = useAtom(translationsAtom);

  useEffect(() => {
    localeMessages[locale]().then((module) => setTranslations(module.default));
  }, [locale, setTranslations]);

  return (
    <IntlProvider locale={locale} messages={translations}>
      {children}
    </IntlProvider>
  );
};
